module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/17-49c50c63b4eb46c36817765ad7cc2383.jpg";